import { Component, OnInit } from '@angular/core';
import { FlashController } from '../../../flash-payment-core/services/flash-controller.service';
import { GlobalService } from '../../../../global.service';

@Component({
  selector: 'app-payment-form',
  templateUrl: './payment-form.component.html',
  styleUrls: ['../way-to-pay.component.sass']
})
export class PaymentFormComponent implements OnInit {

  constructor(public flashPaymentService: FlashController, private global: GlobalService) { }

  ngOnInit(): void {
  }

}
